import Upsertable from '@/models/Upsertable'
import { useCropStore } from '@/stores/cropStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Crop extends Upsertable {
  static store() {
    return useCropStore()
  }

  store() {
    return Crop.store()
  }

  static find(uuid) {
    const obj = Crop.store().find(uuid)
    let crop = new Crop()
    return Object.assign(crop, obj)
  }
}

useModelName(Crop, "Crop")
ModelRegistry.register(Crop, "Crop")